import { render, staticRenderFns } from "./Sucesso.vue?vue&type=template&id=a89b4930&scoped=true"
import script from "./Sucesso.vue?vue&type=script&lang=js"
export * from "./Sucesso.vue?vue&type=script&lang=js"
import style0 from "./Sucesso.vue?vue&type=style&index=0&id=a89b4930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b4930",
  null
  
)

export default component.exports